<template>
  <v-fade-transition mode="out-in">
    <v-app>
    
      <v-content>
        <div id="core-view" class="fill-height">
          <v-fade-transition mode="out-in">
            <router-view/>
          </v-fade-transition>
        </div>
      </v-content>
    
      <notify />
    </v-app>
  </v-fade-transition>
</template>

<script>
  import Notify from './../../UIComponents/Notify'

  export default {
    components: {
      Notify,
      CoreDrawer: () => import('@/components/Dashboard/Layout/Drawer'),
      CoreView: () => import('@/components/Dashboard/Layout/View'),
    },
    metaInfo () {
      return {
        title: "Himydata"
      }
    },
  }
</script>
